import { render, staticRenderFns } from "./PersonnelOpenTable.vue?vue&type=template&id=01d2b9d0"
import script from "./PersonnelOpenTable.vue?vue&type=script&lang=js"
export * from "./PersonnelOpenTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports